import ProductShopPriceEditor from "../shops/ProductShopPriceEditor";
import { resolveProductShop, productShopPath } from "../shops/productShop";
import ProductShopChooser from "../shops/ProductShopChooser";
import { Link } from "react-router-dom";
import React, { useState, useEffect, useRef} from "react";
import Layout from "../Layout/Layout";
import {useNavigate, useParams, useLocation } from "react-router-dom";
import {commentProduct, getProductPreview,  handleUserViewed, getImages, taxProductAreaByState} from "../auth/apiProduct";
import {getAddressUserIfTrue, isAuthenticated, addItem} from "../auth";
import Empty from '../Layout/icon/Unavailable.png'
import imgProductLakay from '../Layout/imgs/md3.jpg' 
import Checkout from "../pageInside/CheckoutProd";
import Vote, {ratingVote} from '../pageInside/commentaire/vote'
import SwiperProdView from '../slider/swiperProdView'
import { elakay_API, toImageUrl } from "../../config";
import { getOptimizedImage } from "../../components/images/resolveImage";
import TabsElakay, {tabElakay} from "../pageInside/html/formTabs";
import { laguangeElakay, elakayAutoText } from "../pageInside/dataElakay";
import Price from "../pageInside/productsPrice"
import { MdAddShoppingCart, MdInfo, MdDescription} from "react-icons/md";
import {FaPlus, FaMinus, FaCheckCircle, FaShoppingBag, FaHome, FaEye } from "react-icons/fa";
import Products from '../pageInside/product'
import LakayUser from '../pageInside/lakayUser'
import CommentaireUser from '../pageInside/commentaire/comentairePro'
import ProductCompareTable from '../pageInside/ProductCompareTable'
import ProductBundleOffer from '../pageInside/productBundles/ProductBundleOffer'
import NewProduct from '../pageInside/NewProduct'
import AddCommentProduct from '../pageInside/commentaire/UserAddCommentsProduct';
import PrevviewProFilt from "../pageInside/prevviewProFilt";
import EmblaCarousel from "../slider/ProdViewSlider/slider"
import Modal from 'react-bootstrap/Modal'
import ShowimagesLoading from "../pageInside/showImagesLoading";
import ShareButton from "../pageInside/ShareButton";
import { findProviderVariantBySelectedFilters } from "../pageInside/dropshippingVariant";
import {extract_Na_Ing_galeries, extract_Urls_galeriesID, extract_K_V_filterProduct, compareArrays, getProductImageUrls} from '../auth/elakay-utils';
import { getPublicIdentifier } from '../../utils/publicIdentifier';
import LocationFilterBar from "../pageInside/LocationFilterBar";
import { BUYER_LOCATION_EVENT, LOCATION_INPUTS_EVENT, readTempBuyerLocation } from '../../utils/buyerLocation';
import { useLocationContext } from '../../utils/locationContext';
import './ProductPreview.css';

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["productPreview"]?.[key] || fallback;

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const cleanTextKey =  (text) => {
    if (typeof text !== 'string') return text;
  
    return text
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace(/[^a-z0-9_]/g, '');
  }

const reLoadImages = (a, b, c, d = "color") => {
  try {
    if (!Array.isArray(a)) {
      console.warn("reLoadImages: 'a' doit être un tableau");
      c([]);
      return;
    }
    if (!b || typeof b !== "object") {
      console.warn("reLoadImages: 'b' invalide");
      c([]);
      return;
    }

    const key = String(d).toLowerCase();
    const wanted = b?.filter?.[key];

    if (!wanted) {
      console.warn(`reLoadImages: aucune valeur pour filter["${key}"]`);
      c([]);
      return;
    }

    const match = a.find(item => item?.name === wanted);

    if (match && Array.isArray(match.images) && match.images.length) {
      c(match.images);
    } else {
      console.warn(`reLoadImages: aucune image pour ${key}="${wanted}"`);
      c([]);
    }
  } catch (err) {
    console.error("reLoadImages error:", err);
    c([]);
  }
};

const loadQueryFil =(a, b, y)=>{
    const variants = Array.isArray(y) ? y : [];
    const selectedFilters = {};

    (Array.isArray(a) ? a : []).forEach((filter) => {
      const key = cleanTextKey(filter?._id?.name);
      const value = key ? b?.get(key) : null;
      if (value) selectedFilters[key] = value;
    });

    const matchingVariant = variants.find((variant) => {
      const variantFilters = variant?.filter || {};
      return Object.entries(selectedFilters).every(([key, value]) =>
        Object.entries(variantFilters).some(
          ([variantKey, variantValue]) => cleanTextKey(variantKey) === key &&
            String(variantValue).trim().toLocaleLowerCase("en-US") === String(value).trim().toLocaleLowerCase("en-US")
        )
      );
    });

    return matchingVariant || variants[0] || null;
}

const resolvePublicVariantInfo = (product, filterProduct) => {
  const variants = product?.dropshippingPublic?.variants;
  if (!Array.isArray(variants) || !filterProduct?._id) return null;
  const filterProductId = String(filterProduct._id);
  return variants.find((variant) => String(variant?.filterProductId || "") === filterProductId)
    || variants.find((variant) => variant?.label === filterProduct?.filter?.variant)
    || null;
};

function isValid(variable) {
    if (variable === null || variable === undefined || variable === "") {
        return false;
    }
    if (Array.isArray(variable) && variable?.length === 0) {
        return false;
    }
    if (typeof variable === "object" && Object.keys(variable)?.length === 0) {
        return false;
    }
    return true;
}

function removeNotSpecified(obj) {
  if (!obj || typeof obj !== "object" || Array.isArray(obj)) return {};
  const result = { ...obj };
  for (const key in result) {
    if (result[key] === "Not Specified") {
      delete result[key];
    }
  }
  return result;
}

const ProFilQuaGrToLe =(a)=>{
    return Array.isArray(a) ? [...a].sort((left, right) => Number(right?.quantity || 0) - Number(left?.quantity || 0)) : []
}

const AddCartFilter =(a, n, f)=>{
    return a?.length > 0 && a?.filter(item =>item?.filter[f] == n)
  }

  const objToArr = (a)=>{
    a = removeNotSpecified(a)
    return a && {v: Object.values(a), k: Object.keys(a)}
}

// A note image as stored: its asset URL, or the legacy per-product route.
const noteImageUrl = (note, index) => toImageUrl(note?.photoUrl) || `${elakay_API}/products/readNoteGalerie/${note?._id}/${index}`;

const getOnlyUrlImages = (galeries = [], max = 4) => {
  const urls = [];
  const append = (value) => {
    if (Array.isArray(value)) return value.forEach(append);
    if (typeof value === "string" && value.trim()) urls.push(value.trim());
    else if (value && typeof value === "object") append(value.urlImg || value.images);
  };
  append(galeries);
  return [...new Set(urls)].slice(0, max);
}

const ProductPreview = (props) => {
    const divProductPreview  = useRef(null);

const scrollToParagraph = (ref) => {
         if (ref && ref.current) {
    ref.current.scrollIntoView({ behavior: 'smooth' });
  }
      };
    const { infoSource } = props
    __setElakayInfoSource(infoSource);

    const {userInfo, readUser} = infoSource

        const { viewed } = infoSource.userInfo

    let params = useParams()
    let query = useQuery();
    // The route always carries the public identifier. Backend mutations must
    // use productObjectId, populated only after the preview response arrives.
    const publicId = params.productId;
    const location = useLocation();
    const params_ = new URLSearchParams(location.search);

     let navigate = useNavigate()

const getFilterQueryByIndex = (data, index = 0, filtersData = [])=>{
  if (!Array.isArray(data)) {
    console.error("❌ 'data' must be an array");
    return null;
  }

  if (typeof index !== "number" || index < 0 || index >= data.length) {
    console.error("❌ invalid index:", index);
    return null;
  }

  const product = data[index];
  if (!product?.filter || typeof product.filter !== "object") {
    console.error("❌ No 'filter' object found in this data element");
    return null;
  }

  let allowedKeys = [];

  if (Array.isArray(filtersData) && filtersData.length > 0) {
    allowedKeys = filtersData
      .map((f) => cleanTextKey(f?._id?.name))
      .filter(Boolean);
  } else {
    allowedKeys = Object.keys(product.filter).map(cleanTextKey);
  }

  const normalizedFilter = Object.entries(product.filter).reduce((acc, [key, val]) => {
    const normalizedKey = cleanTextKey(key);
    if (allowedKeys.includes(normalizedKey)) {
      acc[normalizedKey] = val;
    }
    return acc;
  }, {});

  const queryParts = Object.entries(normalizedFilter).map(
    ([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`
  );

    if (!queryParts.length || location.search) return;
    navigate(`/product/preview/${publicId}?${queryParts.join("&")}`, { replace: true })
}

    const [showComments, setShowComments] = useState(false)
    const [showOrderSuccess, setShowOrderSuccess] = useState(false)
    const [commentsPro, setCommentsPro] = useState([])
    const [sizeComments, SetSizeComments] = useState(0)
    const [limit] = useState(4);
    const [skip, setSkip] = useState(0);
    const { token } = isAuthenticated();
    const [loading, setLoading] = useState(true);
    const [taxprodZone, setTaxProdZone] = useState({});
    const [getProduct, setProduct] = useState({})
    // Seller returned next to the product (data.seller). A Dropshipping Out
    // product carries its owner as an id only, so the comparison table reads
    // the shop name from here.
    const [productSeller, setProductSeller] = useState(null)
    const [selectedShopId, setSelectedShopId] = useState(null);
    const [priceVersion, setPriceVersion] = useState(0);
    const resolvedShop = resolveProductShop({ product: getProduct, selectedShopId, currentShopId: params_.get('shop') });
    useEffect(() => { setSelectedShopId(null); }, [publicId]);
    const productObjectId = getProduct?._id || null
    // The owner arrives populated for native products but as a plain id for
    // CJ/dropshipping ones: both must give the seller (Lakay <shop> block, cart).
    const productOwnerId = typeof getProduct?.owner === "string" ? getProduct.owner : getProduct?.owner?._id || null
    const productOwnerRef = getPublicIdentifier(getProduct?.owner, productOwnerId)
    const [galeries, setGaleries] = useState([])
    const [images, setImages] = useState([])
    const [unSeFil, setUnSefil] = useState(false)
    const [categoryID, setCategoryID] = useState('')
    const [oneFilterPro, setOneFilterPro] = useState({})
    // Variante CJ sélectionnée (voir CJVariantSwatches.jsx) : { label, price }.
    // price est déjà recalculé serveur (buildCustomerVariantSwatches,
    // cjProductSyncService.js) quand le coût fournisseur de cette variante
    // diffère du produit "de base" -- jamais recalculé ici, jamais dérivé de
    // priceFil (voir checkFilterPrice plus bas). Nommé différemment de la
    // variable locale `selectedVariant` de loadProductsView (moteur de
    // filtres générique existant, sans rapport) pour éviter toute confusion.
    const [selectedCJVariant, setSelectedCJVariant] = useState(null)
    const [restAllFilterPro, setRestALLFilterPro] = useState({})
    const [allFilterPro, setALLFilterPro] = useState({})
    const [filters, setFilters] = useState([]);
    const [getQueryFil, setQueryFil] = useState({});
    const [quantity, setQuantity] = useState(0)
    const [count, setcount] = useState(1)
    const [parcel, setParcel] = useState()
    const [addressShop, setAddressFrom] = useState({})
    const [itemUnAvailable, setItemUnAvailable] = useState(false);
    // Location Context: the destination availability, shipping and taxes are
    // computed for (Target Location > address > approximate IP, resolved by
    // the server). `locationBlocked` = the seller's Strict Location zone
    // excludes it (server answered PRODUCT_UNAVAILABLE_IN_LOCATION).
    const [locationBlocked, setLocationBlocked] = useState(null);
    const [locationVersion, setLocationVersion] = useState(0);
    const locationContext = useLocationContext();
    useEffect(() => {
        const bump = () => setLocationVersion((v) => v + 1);
        window.addEventListener(BUYER_LOCATION_EVENT, bump);
        window.addEventListener(LOCATION_INPUTS_EVENT, bump);
        return () => {
            window.removeEventListener(BUYER_LOCATION_EVENT, bump);
            window.removeEventListener(LOCATION_INPUTS_EVENT, bump);
        };
    }, []);
    const [getUserVote, setUserVote]= useState()
    const [cat_Product, setCat_Product] = useState()
    // Variante 3 — depuis l'URL (si tu utilises react-router)

const [key, setKey] = useState(params_.get('tab') || 'details');
    let filArrName = []
    const [Saddress, setSAddressFinal] = useState({
        firstName: "",
        lastName: "",
        city: "",
        country: "",
        line1: "",
        postal_code: "",
        state: ""
    });

const getTaxProdArea = (code, zipCode, regionCode) => {
    taxProductAreaByState(code, zipCode, regionCode).then(data => {
        if (!data || data.error){
     }else{
        setTaxProdZone(data.zoneTax)
     }
    })
};

        useEffect(() => {
            const controller = new AbortController()
            loadProductsView(publicId, controller.signal)

            addressId(token)
             if (!locationVersion) scrollToParagraph(divProductPreview)
            infoSource.getLangaugeAPI()
            return () => controller.abort()
        // locationVersion: a new Target Location / address re-checks availability
        // and re-prices shipping for the new destination.
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [publicId, locationVersion, selectedShopId, location.search, priceVersion]);
    

        const creatViewedUser = (productObjectId, token)=>{
               
            productObjectId && handleUserViewed(token, productObjectId, viewed)
            .then(data => {readUser(token)}).catch(err => { });
            
        }

        const addressId = (token) => {
      getAddressUserIfTrue(token).then(data => {
    if (!data || data.error || !Array.isArray(data) || !data[0] || typeof data[0] !== "object") {
      return;
    }
    const address = data[0];
    setSAddressFinal({
      firstName: address.firstName || "",
      lastName: address.lastName || "",
      tel: address.tel || "",
      city: address.city || "",
      country: address.country || "",
      line1: address.Address1 || "",
      postal_code: address.postalCode || "",
      state: address.State || ""
    });
    getTaxProdArea(address.country, address.postalCode, address.State);
    }).catch(err => {
    console.error("❌ Error while fetching address:", err);
    });
    }

        const loadProductsView = (previewPublicId, signal) => {
            setLoading(true);
            setItemUnAvailable(false);
            setLocationBlocked(null);
            setProduct({});
            setProductSeller(null);
            setCommentsPro([]);
            SetSizeComments(0);
            setSelectedCJVariant(null);
            getProductPreview(previewPublicId, signal, selectedShopId || params_.get('shop')).then(data => {
                // console.log("Product Preview Data:", JSON.stringify(data, null, 2));
                if (signal?.aborted) return;
                if (data?.code === "PRODUCT_UNAVAILABLE_IN_LOCATION") {
                    setLocationBlocked(data.location || { available: false })
                    setLoading(false)
                } else if (!data || data.err || data.error || !data.product) {
                    setItemUnAvailable(true)
                    setLoading(false)
                } else {
                    const hydratedProduct = data.product.owner || !data.seller
                      ? data.product
                      : { ...data.product, owner: data.seller };
                    creatViewedUser(hydratedProduct._id, token)
                    const gal = Array.isArray(data.galeries) ? data.galeries : (data.product.galeries || [])
                    const prodFil = ProFilQuaGrToLe(data.filterProduct || hydratedProduct.filterProduct)
                    const catID = Array.isArray(hydratedProduct.categoriesID) ? hydratedProduct.categoriesID : []
                    const filt = Array.isArray(data.filters) ? data.filters : (hydratedProduct?.filters || [])
                    const selectedVariant = loadQueryFil(filt, query, prodFil)
                    const selectedPublicVariant = resolvePublicVariantInfo(hydratedProduct, selectedVariant)

            loadImages(hydratedProduct._id, gal, selectedVariant, hydratedProduct)
            if (selectedPublicVariant?.image) {
              const productImages = getProductImageUrls(hydratedProduct, 20);
              setImages([selectedPublicVariant.image, ...productImages.filter((url) => url !== selectedPublicVariant.image)])
            }
            setProduct({ ...hydratedProduct, filters: filt })
            setProductSeller(data.seller || null)
            getFilterQueryByIndex(prodFil, 0, filt)
            setOneFilterPro(selectedVariant || {})
            setSelectedCJVariant(selectedPublicVariant)
            setALLFilterPro(prodFil)
            setRestALLFilterPro(prodFil)
            data.shopAddress &&  setAddressFrom(data.shopAddress) 
            setGaleries(gal) 
            setCat_Product(catID[0]?.catID)
            setFilters(catID[0]?.catID?.filter || [])
            setCategoryID(catID[0]?.catID?._id || catID[0]?.catID || '')
            setNewAP(selectedVariant, prodFil)
            loadComments(hydratedProduct._id, 0)
            setLoading(false)
            } 
            }).catch(() => {
              if (signal?.aborted) return;
              setItemUnAvailable(true);
              setLoading(false);
            })
        }; 

        const setNewAP = (variant, variants = restAllFilterPro)=>{
          if (!variant) return;
          const variantQuantity = Number(variant.quantity) || 0;
          setQuantity(variantQuantity)
          setcount((currentCount) => variantQuantity > 0 ? Math.min(Math.max(Number(currentCount) || 1, 1), variantQuantity) : 1)
          const fallbackParcel = Array.isArray(variants) ? variants.find(item => item?.parcel)?.parcel : null;
          setParcel(variant.parcel || fallbackParcel || {})
        }

        const selectCoordinatedVariant = (variant) => {
          setOneFilterPro(variant || {})
          const publicVariant = resolvePublicVariantInfo(getProduct, variant)
          setSelectedCJVariant(publicVariant)
          const visibleFilterKeys = new Set((getProduct?.filters || []).map((entry) => cleanTextKey(entry?._id?.name)).filter(Boolean))
          const nextQuery = new URLSearchParams(location.search)
          visibleFilterKeys.forEach((key) => nextQuery.delete(key))
          Object.entries(variant?.filter || {}).forEach(([key, value]) => {
            const normalizedKey = cleanTextKey(key)
            if (visibleFilterKeys.has(normalizedKey) && value !== undefined && value !== null) {
              nextQuery.set(normalizedKey, value)
            }
          })
          navigate(`/product/preview/${publicId}?${nextQuery.toString()}`, { replace: true })
          if (publicVariant?.image) {
            setImages((currentImages) => [
              publicVariant.image,
              ...(Array.isArray(currentImages) ? currentImages : []).filter((url) => url !== publicVariant.image),
            ])
          }
        }
  
        const loadImages =(Id, a, b, c=[])=> {  
            setUnSefil(false)
            const galleries = Array.isArray(a) ? a : [];
            const directImages = getProductImageUrls(c, 20);
            const isDropshippingProduct = c?.sourceType === "dropshipping";
            // Dropshipping In (server_elakay's providerSellerSync.js) mirrors the Provider's images
            // into a galeries entry named "Provider", never "all Filter" -- so the branch below
            // (which only looks for "all Filter") never finds it, and the main image was blank.
            // getProductImageUrls already reads that "Provider" entry (and ProductImageUrls if
            // synced), same as it already does for CJ, so the SAME reliable branch below applies.
            const isProviderInternalProduct = c?.sourceType === "provider_internal";
            let da = galleries.find(item => item?.name === "all Filter");
    const K_V_filterProduct = extract_K_V_filterProduct(c?.filterProduct);
     const MatrGaleries = extract_Na_Ing_galeries(c?.galeries);
     const valuesArray = Array.from(query.values());
            if ((isDropshippingProduct || isProviderInternalProduct) && directImages.length) {
              // Pour CJ et Dropshipping In, ProductImageUrls/galeries.Provider est déjà la liste
              // complète issue de la synchronisation. Une galerie synthétique ou un filtre vide
              // ne doit jamais l'écraser.
              setUnSefil(Boolean(da));
              setImages(directImages);
            } else if(da && Array.isArray(da.images) && da.images.length) {
             setUnSefil(true)
              setImages(da.images)
            } else if (!compareArrays(K_V_filterProduct.values, valuesArray).error && b && galleries[0]?.images?.length){
                reLoadImages(galleries,  b, setImages)
            }else if (directImages.length) {
                setImages(directImages)
            }else{
            getImages(Id).then(data => {
                const fallbackImages = getOnlyUrlImages(data?.galeries, 20);
                if (!fallbackImages.length) {
                    setImages([imgProductLakay])
                } else {
                    setImages(fallbackImages)
                }
            }).catch(() => setImages([imgProductLakay]))
        }
        };
      
const addToCart = () => {
    if (!productObjectId || !oneFilterPro?._id || quantity <= 0 || Number(count) > quantity) return;
    // toImageUrl resolves the relative /elakay_api/image-assets/... path Dropshipping In (and any
    // other locally-hosted) image is legitimately stored as -- same helper ShowImage/CardCart
    // already use to display it correctly in Cart; never a no-op for an external CDN URL.
    let urlImg = toImageUrl(images[0])
    let filterProduct = oneFilterPro
    if (token) {
    addItem(token, { shopId: resolvedShop?._id, "count": count, "categoryID": categoryID, "productID": productObjectId, "productOrner": productOwnerId, urlImg, filterProduct: filterProduct?._id}).then(response => {
        infoSource.cartItems(token)
    }).catch(error => {
    });
}else {
    return window.location.href = "/signin"
}
};

const loadComments = (targetProductObjectId, targetSkip = skip) => {
    if (!targetProductObjectId) return Promise.resolve(null)
    return commentProduct(targetProductObjectId, targetSkip, limit).then(data => {
        if (data && !data.error) {
            setCommentsPro(data.commentsPagination)
            SetSizeComments(data.commentsCount?.[0]?.totalComments)
            setUserVote(data.userVote?.[0]?.vote)
        }
        return data
    })
}

const ButtonAddComments=(show= true)=>{
    if (!productObjectId) return
    show && setShowComments(true)
    loadComments(productObjectId)
         !isAuthenticated() && show && showComments &&( window.location.href = "/signin")
}

let voteRating = ratingVote(getProduct.vote)
const etoiteProduct = (
    <>
        {voteRating && (<h5 className='p-0 m-0 product-star-rating'><Vote  rating={voteRating}/></h5>)}
        {!voteRating && (<h5 className='p-0 m-0 product-star-rating'><Vote rating={0} /></h5>)}
    </>
    )

    let filterColor  = oneFilterPro && oneFilterPro?.filter
    let arrayFilter =  objToArr(filterColor)

const filterDetail = () => (
    <div className="fd-wrap">
        {arrayFilter && arrayFilter.k?.map((key, i) => (
            <div
                key={i}
                className={`fd-row ${i % 2 === 1 ? 'alt' : ''}`}
            >
                <span className="fd-key">{key}</span>
                <span className="fd-val">{arrayFilter.v[i]}</span>
            </div>
        ))}
    </div>
);
    
const descriptionProduct = (
        getProduct?.note?.length > 0  &&
          <div className="product-description-content">
            {getProduct.note?.map((k, j) => (
                k.tilte && (
                <div key={j} className="product-note-item">
                <p className="product-note-title">{k.tilte}</p>
                    <p className="product-note-description">{k.description}</p>
                </div>
                )
            ))
            }
        </div>
    )

     const showImgNote = (
         getProduct?.note?.length > 0 && <div 
        //  className="product-images-note-section"
         > 
        <div 
        className="product-images-note-wrapper"
        >
        <div 
        className="product-images-note-grid"
        >
            {getProduct.note && getProduct.note?.length > 0 && getProduct.note?.map((k, j) => (
                !k.tilte && (
                    <div key={j} className="product-note-image-item">
                           <img
                               // Same pixels as the stored image (never enlarged), in a lighter format.
                               src={getOptimizedImage(noteImageUrl(k, j), { preset: 'product-zoom' })}
                                alt={__elakayText("t005", "Elakay note images")}
                                onError={event => {
                                        const image = event.target
                                        const original = noteImageUrl(k, j)
                                        // Lighter copy unavailable: the stored image once, then the placeholder.
                                        if (image.dataset.noteOriginal !== original && image.getAttribute('src') !== original) {
                                            image.dataset.noteOriginal = original
                                            image.src = original
                                            return
                                        }
                                        image.src = imgProductLakay
                                        event.onerror = null
                                      }}
                              />
                    </div>
                )
            ))
            }
        </div></div></div>
    )

const checkFilterPrice =(filPrice, prodPrice)=>{
    // Dropshipping variants (filterProduct[].priceFil) are synced straight
    // from the supplier and never carry the seller's own margin -- only
    // product.price/salePrice (set by the seller, e.g. via the CJSyncModal
    // pricing step) is ever charged/displayed. This used to fall through to
    // filPrice whenever a CJ-synced variant had a stale priceFil > 0, which
    // showed/charged the supplier's at-cost price instead of the seller's.
    //
    // selectedVariant.price is DIFFERENT from filPrice/priceFil: it's not the
    // raw CJ supplier cost, it's a full sellingPrice already recomputed
    // server-side (buildCustomerVariantSwatches, cjProductSyncService.js)
    // from the seller's own target profit/discount/shipping -- the same
    // engine as the "Shipping & Price" step of the sync wizard, just solved
    // for this one variant's own CJ cost. Safe to charge/display.
    if (getProduct?.sourceType === "dropshipping") {
        return selectedCJVariant?.price > 0 ? selectedCJVariant.price : prodPrice
    }
    let checkprice = false
    if (filPrice === undefined){
        checkprice = true
    }else if (filPrice === null) {
        checkprice = true
    }else if (filPrice <= 0) {
        checkprice = true
    }else {
        checkprice = false
    }

   return checkprice ? prodPrice : filPrice
}

const priceProd = {price: checkFilterPrice(oneFilterPro?.priceFil,  getProduct.price), salePrice: getProduct.salePrice, count}

// Titre affiché : celui de la variante sélectionnée quand il diffère
// vraiment du titre principal (CJ nomme chaque variante "{titre produit}
// {suffixe}" -- comparer un préfixe évite d'afficher un titre "différent"
// alors qu'il ne fait que répéter le même texte).
const displayedTitle = selectedCJVariant?.label
    ? selectedCJVariant.label.startsWith(getProduct?.name || "")
      ? selectedCJVariant.label
      : `${getProduct?.name || ""} – ${selectedCJVariant.label}`
    : getProduct?.name

const stock = (a) => {
  if (a == 0) {
        return <h6 className="stock-label stock-unavailable">{infoSource.laguangeElakay('text', infoSource.languageAPI).textCardCart1}</h6> 
       }
       else if (a < 20) {
        return <h6 className="stock-label stock-low"> {infoSource.laguangeElakay('text', infoSource.languageAPI).textCardCart2} {a} {infoSource.laguangeElakay('text', infoSource.languageAPI).textCardCart3}</h6>
       }
        else if (a >= 20) {
        return <h6 className="stock-label stock-available"> {infoSource.laguangeElakay('text', infoSource.languageAPI).textCardCart4}</h6>
        }}

        const handleChange = event => {
            if (event.target.value >= 1) {
                setcount(event.target.value)
            }
        };
        const buttonPLus = () => {
            let newCount = count 
            newCount ++
            if (newCount <= quantity) setcount(newCount)
        }
    
        const buttonMimus = () => {
             let newCount = count 
               newCount --
            if (newCount  >= 1) {     
                setcount(newCount)
            }
        }

        const inputCart = () => {
            return (
                <div className="quantity-selector">
                    <button className="quantity-btn quantity-minus" onClick={buttonMimus}>
                        <FaMinus />
                    </button>
                    <input
                        onChange={handleChange}
                        type="number"
                        className="quantity-input"
                        min="1"
                        max={Math.max(quantity, 1)}
                        value={count}
                    />   
                    <button className="quantity-btn quantity-plus" onClick={buttonPLus}>
                        <FaPlus />
                    </button>
                </div>)}

const selectedFiltersForOrder = oneFilterPro?.filter || {};
const checkoutProviderVariant = selectedCJVariant || findProviderVariantBySelectedFilters(
        getProduct.dropshippingPublic?.variants,
        selectedFiltersForOrder
    );

const cartItemsPRoNew = [{
        shopId: resolvedShop?._id,
        productID: productObjectId,
        // Same toImageUrl() normalization as addToCart() above -- Checkout's own validation
        // (CheckoutProd.js) now also tolerates a relative path, but resolving it here too keeps
        // ProductPreview and Checkout from ever having two different ideas of "the product image".
        urlImg: toImageUrl(images[0]),
        filterPro: oneFilterPro?._id,
        catID: oneFilterPro?.catID,
        filter: oneFilterPro?.filter || [],
        selectedFilters: selectedFiltersForOrder,
        sourceType: getProduct.sourceType === "dropshipping" ? "dropshipping" : "standard",
        providerPlatform: getProduct.sourceType === "dropshipping" ? {
          platformName: getProduct.dropshippingPublic?.platformName || null,
        } : null,
        selectedProviderVariant: checkoutProviderVariant,
        selectedVariantId: checkoutProviderVariant?.externalVariantId || null,
        selectedVariantSku: checkoutProviderVariant?.sku || null,
        price: checkFilterPrice(oneFilterPro?.priceFil,  getProduct.price),
        sold: getProduct.sold,
        count,
        cat_Product,
        salePrice: getProduct.salePrice,
        graphic:  getProduct.graphic,
        creatorDesign:  getProduct.creatorDesign,
        taxprodZone,
        paymentIntent:{
            customer: infoSource.userInfo.StripeCustomerId,
            payment_method: null,
        }
        }]

const DataProFilt = {
filArrName,
setOneFilterPro,
setALLFilterPro,
restAllFilterPro,
filterProduct : allFilterPro,
filter : getProduct.filter
}

  // ── Description composée : texte + notes ──────────────
const descrip = (
    <div className="pd-desc">
        {/* Texte principal */}
        {getProduct.description && (
            <div className="pd-desc-main">
                <p>{getProduct.description}</p>
            </div>
        )}
        {/* Notes (descriptionProduct) */}
        {getProduct.note?.length > 0 &&
            getProduct.note.map((k, j) =>
                k.tilte ? (
                    <div key={j} className="pd-note-item">
                        <div className="pd-note-title">{k.tilte}</div>
                        <div className="pd-note-body">{k.description}</div>
                    </div>
                ) : null
            )
        }
    </div>
);

const buttonAddCart = (classCart = "btn btn-md btn-info btn-block") => {
   const disabled = !productObjectId || !oneFilterPro?._id || quantity <= 0 || Number(count) > quantity;
   return <button type="button" className={classCart} onClick={addToCart} disabled={disabled}>
        <MdAddShoppingCart />
        {infoSource.laguangeElakay('Button', infoSource.languageAPI).addCart}
    </button>
}

// Destination used for the shipping / tax ESTIMATE before a delivery address
// is chosen in the checkout box: the consumer's Target Location, else the
// approximate IP location (addresses already reach Checkout via Saddress).
const ctxLocation = locationContext.location;
const provisionalDestination = ctxLocation && ["target", "ip"].includes(ctxLocation.source) && ctxLocation.country
    ? {
        country: ctxLocation.country,
        state: ctxLocation.state || "",
        city: ctxLocation.city || "",
        postal_code: ctxLocation.postalCode || "",
        source: ctxLocation.source,
        approximate: Boolean(ctxLocation.isApproximate),
        label: ctxLocation.label || "",
    }
    : null;

const productView = () => {

    if (locationBlocked) return (
        <div className="pv-main">
            <div className="pv-unavail" data-testid="product-unavailable-location">
                <img src={Empty} alt="" className="product-unavailable-image" />
                <div className="pv-unavail-title">{elakayAutoText("h_locctx_product_unavailable", "Not available in your selected location")}</div>
                <div className="pv-unavail-sub">
                    {locationBlocked.label
                        ? `${elakayAutoText("h_locctx_product_unavailable_area", "This seller only sells in a limited area, which does not include")} ${locationBlocked.label}${locationBlocked.isApproximate ? ` (${elakayAutoText("h_locctx_approximate", "approximate location")})` : ""}.`
                        : elakayAutoText("h_locctx_product_choose_location", "This seller only sells in a limited area. Choose a delivery location to check availability.")}
                </div>
                <LocationFilterBar infoSource={infoSource} location={readTempBuyerLocation()} />
            </div>
        </div>
    );

    if (itemUnAvailable) return (
        <div className="pv-main">
            <div className="pv-unavail">
                <img src={Empty} alt={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).productPreview.t001}
                    className="product-unavailable-image" />
                <div className="pv-unavail-title">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).productPreview.t002}</div>
                <div className="pv-unavail-sub">{__elakayText("t004", "This item is no longer available")}</div>
            </div>
        </div>
    );

    return (
        <div className="pv-main">
            <div className="pv-grid">

                {/* ── Galerie ── */}
                <div className="pv-gallery">
                    {images?.length > 0
                        ? <EmblaCarousel slides={images} options={{}} infoSource={infoSource} />
                        : <div className="pv-gallery-ph" />
                    }
                </div>

                {/* ── Info ── */}
                <div className="pv-info">

                    <div className="product-rating-section">
                        {etoiteProduct}
                        <ShareButton
                            infoSource={infoSource}
                            title={getProduct.name}
                            className="pv-share"
                        />
                    </div>

                    <ProductShopChooser product={getProduct} shop={resolvedShop} onChange={setSelectedShopId} />
                    <ProductShopPriceEditor product={getProduct} shop={resolvedShop} onSaved={() => setPriceVersion((old) => old + 1)} />

                    {getProduct?.owner && <Link to={productShopPath(getProduct, resolvedShop)}>{infoSource.getButtonTitle('viewShop')}{resolvedShop?.name ? ` · ${resolvedShop.name}` : ''}</Link>}
                    <h1 className="pv-title">{displayedTitle}</h1>

                    {/*
                      Pas de description par variante : CJ ne fournit qu'un
                      `name` par variante (voir dropshippingPublic.variants,
                      cjProductSyncService.js), aucune donnée "description"
                      distincte -- rien de fiable à afficher à la place de la
                      description produit ici sans l'inventer.
                    */}
                    <div
                        className="pv-desc"
                        dangerouslySetInnerHTML={{ __html: getProduct?.description }}
                    />

                    <div className="pv-price-row">
                        <Price showAddToCartButton={false} products={priceProd} />
                    </div>

                    <div className="product-stock-section">
                        {stock(quantity)}
                    </div>

                    <div className="product-quantity-section">
                        {inputCart()}
                    </div>

                    <div className="pv-filters">
                        <PrevviewProFilt
                                    infoSource={infoSource}
                                    setQuantity={setQuantity}
                                    galeries={galeries}
                                    unSeFil={unSeFil}
                                    setUnSefil={setUnSefil}
                                    setImages={setImages}
                                    oneFilterPro={oneFilterPro}
                                    setOneFilterPro={selectCoordinatedVariant}
                                    setALLFilterPro={setALLFilterPro}
                                    restAllFilterPro={restAllFilterPro}
                                    allFilterPro={allFilterPro}
                                    filter={getProduct?.filters}
                                    getQueryFil={getQueryFil}
                                    setNewAP={setNewAP}
                                />
                    </div>
                </div>

                {/* ── Checkout ── */}
                <div className="pv-checkout">
                    <div className="pv-checkout-card">
                        <span className="pv-checkout-title">
                            {infoSource.laguangeElakay('label', infoSource.languageAPI).orderSummary || 'Order summary'}
                        </span>

                        {productObjectId ? <Checkout
                            provisionalDestination={provisionalDestination}
                            Saddress={Saddress}
                            setSAddressFinal={setSAddressFinal}
                            graphic={getProduct.graphic}
                            addressShop={addressShop}
                            addressSel={infoSource.address}
                            products={cartItemsPRoNew}
                            owner={getProduct.owner}
                            quantity={quantity}
                            galeries={getProduct.galeriesID}
                            count={count}
                            parcel={parcel}
                            laguangeElakay={laguangeElakay}
                            infoSource={infoSource}
                            buttonAddCart={buttonAddCart}
                            aboveActions={<ProductBundleOffer productId={productObjectId} infoSource={infoSource} Saddress={Saddress} setSAddressFinal={setSAddressFinal} onOrderSuccess={() => setShowOrderSuccess(true)} />}
                            onOrderSuccess={() => setShowOrderSuccess(true)}
                        /> : <div className="pv-checkout-loading" aria-busy="true" />}
                    </div>

                </div>
            </div>

            {/* ── Tabs Details / Description ── */}
            <div className="pv-tabs-section">
                <div className="pd-tabs">
                    <button
                        className={`pd-tab ${key === 'details' ? 'on' : ''}`}
                        onClick={() => setKey('details')}
                    >
                        <MdInfo />{__elakayText("t006", "Details")}</button>
                    <button
                        className={`pd-tab ${key === 'description' ? 'on' : ''}`}
                        onClick={() => setKey('description')}
                    >
                        <MdDescription />{__elakayText("t007", "Description")}</button>
                </div>

                <div className="pd-body">
                    {key === 'details' && (
                        <div className="pd-panel">
                            {filterDetail()}
                        </div>
                    )}
                    {key === 'description' && (
                   <div className="pd-desc">
        {/* Texte principal */}
        {getProduct.description && (
            <div className="pd-desc-main">
                <p>{getProduct.description}</p>
            </div>
        )}
        {/* Notes (descriptionProduct) */}
        {getProduct.note?.length > 0 &&
            getProduct.note.map((k, j) =>
                k.tilte ? (
                    <div key={j} className="pd-note-item">
                        <div className="pd-note-title">{k.tilte}</div>
                        <div className="pd-note-body">{k.description}</div>
                    </div>
                ) : null
            )
        }
    </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const ProductPageView =()=>(
    <div className="product-page-view-container">
        {productView()}
         { categoryID &&  <Products
                laguangeElakay={laguangeElakay}
                infoSource ={infoSource}
                categoryID={categoryID}
                SliderPunShow={true}
                showB={false}
            />}
        {productOwnerId &&  <LakayUser
                laguangeElakay={laguangeElakay}
                infoSource ={infoSource}
                shopId={resolvedShop?._id}
                addressShop={addressShop}
                userID={productOwnerRef}
                showB={false}
            />}
       {getProduct?.ProdCompare?.length > 0 && (
            <ProductCompareTable
                currentProduct={getProduct}
                currentSeller={productSeller}
                compareProducts={getProduct.ProdCompare.map((entry) => entry?._id).filter(Boolean)}
            />
        )}
       {productObjectId && commentsPro && <CommentaireUser
                infoSource={infoSource}
                skip={skip}
                limit={limit}
                voteA={getUserVote} 
                comments={commentsPro}
                productId={productObjectId}
                token={token}
                setCommentsPro={setCommentsPro}
                SetSizeComments={SetSizeComments}
                setUserVote={setUserVote}
                setShowComments={setShowComments}
                commentProduct={commentProduct}
                loadProductsView={loadProductsView}
                ButtonAddComments={ButtonAddComments}
                showComments={showComments}
            />}
            {showImgNote}
    </div>
)

const printListeShop = () => (
    <div className="comments-modal-container">
        <div className="comments-modal-wrapper">
            <Modal
                size="xl"
                show={showComments}
                onHide={() => setShowComments(false)}
                aria-labelledby="example-custom-modal-styling-title"
                centered
                className="product-comments-modal"
            >
              <div className="m-4">
                                    <button
          className="tracking-close-btn"
          onClick={() => setShowComments(false)}
          aria-label={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).productPreview.t003}
        >
          ×
        </button>
                {/* <Modal.Body> */}

                {productObjectId && <AddCommentProduct
                                showComments={showComments}
                                ButtonAddComments={ButtonAddComments}
                                infoSource ={infoSource}
                                ProductsViewload={loadProductsView}
                                comments={commentsPro}
                                userInfo={infoSource.userInfo}
                                voteA={getUserVote}
                                productId={productObjectId}
                                setShowComments={setShowComments}
                                sizeComments={sizeComments}
                                commentProduct={commentProduct}
                                setUserVote={setUserVote}
                                setCommentsPro={setCommentsPro}
                                SetSizeComments={SetSizeComments}
                                size={commentsPro?.length}
                                skip={skip}
                                limit={limit}
                                setSkip={setSkip}
                                />
                                }
                {/* </Modal.Body> */}
                </div>
            </Modal>
        </div>
    </div>
)

const orderSuccessModal = () => (
    <Modal
        show={showOrderSuccess}
        onHide={() => setShowOrderSuccess(false)}
        centered
        aria-labelledby="order-success-modal-title"
        contentClassName="pv-order-success-modal"
    >
        <button
            type="button"
            className="pv-os-close"
            onClick={() => setShowOrderSuccess(false)}
            aria-label={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).productPreview.t003}
        >
            ×
        </button>
        <div className="pv-os-body">
            <div className="pv-os-icon"><FaCheckCircle /></div>
            <h3 id="order-success-modal-title" className="pv-os-title">
                {__elakayText("t008", "Votre commande a été bien effectuée.")}
            </h3>
            <p className="pv-os-sub">{__elakayText("t009", "Voulez-vous continuer ?")}</p>
            <p className="pv-os-payment-message">{elakayAutoText("h_checkout_wait_acceptance", "Payment authorized, awaiting acceptance by the Seller or delegated Provider. No further payment is needed.")}</p>
            <div className="pv-os-actions">
                <button
                    type="button"
                    className="pv-os-btn pv-os-btn--primary"
                    onClick={() => { setShowOrderSuccess(false); navigate("/c/orders"); }}
                >
                    <FaShoppingBag /> {__elakayText("t010", "Mes commandes")}
                </button>
                <button
                    type="button"
                    className="pv-os-btn pv-os-btn--outline"
                    onClick={() => { setShowOrderSuccess(false); navigate("/"); }}
                >
                    <FaHome /> {__elakayText("t011", "Accueil")}
                </button>
                <button
                    type="button"
                    className="pv-os-btn pv-os-btn--outline"
                    onClick={() => {
                        setShowOrderSuccess(false);
                        navigate("/product/preview/" + publicId + location.search);
                    }}
                >
                    <FaEye /> {__elakayText("t012", "Voir le produit")}
                </button>
            </div>
        </div>
    </Modal>
)

    return (
        <Layout
            className="product-preview-layout"
            SliderPunShow={false}
            infoSource ={infoSource}
             loading={loading}
             {...infoSource?.allSettings?.layout}
        >
            <div ref={divProductPreview} style={infoSource.styleNav} className="product-preview-container">
          {ProductPageView()}
        {printListeShop()}
        {orderSuccessModal()}
          <NewProduct
                    laguangeElakay={laguangeElakay}
                    infoSource ={infoSource}
                    readUser={infoSource.readUser}
                    showB={false}
        />
        </div>
      </Layout>
    );
}

export default ProductPreview
